import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { Loader2, ArrowLeft } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(f);
      nav("/access");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-stretch bg-background terminal-bg">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-12 relative overflow-hidden border-r border-border">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="relative z-10 flex items-center gap-3">
          <img src="/tmc-logo.png" alt="The Money Club" className="w-12 h-12 rounded-xl border border-primary/40" />
          <span className="font-head font-extrabold text-white text-lg tracking-wide">THE MONEY CLUB</span>
        </div>
        <div className="relative z-10">
          <h1 className="font-head text-4xl font-extrabold text-white leading-tight">Dołącz do<br /><span className="gold-text">The Money Club</span>.</h1>
          <p className="text-gray-400 mt-5 max-w-md">Załóż konto, dołącz do społeczności i zdobądź dostęp do akademii, sygnałów i wsparcia traderów.</p>
        </div>
        <div className="relative z-10 text-xs text-muted-foreground font-mono">Handel niesie wysokie ryzyko straty kapitału.</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md fade-up">
          <button onClick={() => nav("/login")} className="text-sm text-muted-foreground hover:text-white flex items-center gap-1 mb-4"><ArrowLeft className="w-4 h-4" /> Powrót do logowania</button>
          <div className="flex items-center gap-2 mb-6 lg:hidden">
            <img src="/tmc-logo.png" alt="TMC" className="w-12 h-12 rounded-xl border border-primary/40" />
            <span className="font-head font-extrabold text-white">THE MONEY CLUB</span>
          </div>
          <h2 className="font-head text-2xl font-bold text-white">Rejestracja</h2>
          <p className="text-sm text-muted-foreground mb-6">Utwórz konto w The Money Club</p>
          <form onSubmit={submit} className="space-y-3">
            <div className="grid grid-cols-2 gap-3">
              <input value={f.first_name} onChange={set("first_name")} required placeholder="Imię" data-testid="reg-first-name" className="bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
              <input value={f.last_name} onChange={set("last_name")} required placeholder="Nazwisko" data-testid="reg-last-name" className="bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
            </div>
            <input value={f.email} onChange={set("email")} type="email" required placeholder="Adres e-mail" data-testid="reg-email" className="w-full bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
            <input value={f.phone} onChange={set("phone")} placeholder="Numer telefonu (opcjonalnie)" data-testid="reg-phone" className="w-full bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
            <input value={f.password} onChange={set("password")} type="password" required placeholder="Hasło (min. 8 znaków)" data-testid="reg-password" className="w-full bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
            {error && <div className="text-sm text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2" data-testid="reg-error">{error}</div>}
            <button type="submit" disabled={busy} data-testid="reg-submit"
              className="w-full bg-primary hover:opacity-90 text-black font-bold rounded-lg px-4 py-2.5 transition-all active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-60">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Załóż konto
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
